import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DynamicTable from "../../components/dynamicTable";

const tableHeader = [
  "JOB ID",
  "CUSTOMER NAME",
  "JOBS",
  "ADDRESS",
  "CREATED AT",
  "LOCATION",
  "STATUS",
  "ACTIONS",
];

const displayRows = [
  "jobId",
  "customer_details",
  "jobs_details",
  "address",
  "created_at",
  "location",
  "jobStatus",
  "eye",
];

const GroupJobTable = ({ tableData = [] }) => {
  const navigate = useNavigate();

  const handleJobDetails = (row) => {
    navigate(`/jobs-details/${row?._id}`, { state: row });
  };

  return (
    <Box>
      <DynamicTable
        tableHeader={tableHeader}
        displayRows={displayRows}
        tableData={tableData}
        showPagination={true}
        showUserMenu={true}
        onEyeClick={handleJobDetails}
      />
    </Box>
  );
};

export default GroupJobTable;
